import axios from "axios";

const actions = {
  async listPolicy(context, payload) {
    try {
      const response = await this.$api.call("flight.listPolicy", payload);
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationPolicies", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationPolicies", responseData);
      }
      context.commit("mutationPoliciesMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationPolicies", []);
      context.commit("mutationPoliciesMeta", {});

      throw error;
    }
  },

  async detailPolicy(context, payload) {
    try {
      const response = await this.$api.call("flight.detailPolicy", payload);
      const responseData = response.data;

      context.commit("mutationPolicy", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPolicy", {});
      throw error;
    }
  },

  async sharePolicy(_context, payload) {
    try {
      const response = await this.$api.call("flight.sharePolicy", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async listClaim(context, payload) {
    try {
      const response = await this.$api.call("flight.listClaim", payload);
      const responseData = response.data;

      if (typeof payload.tab !== "undefined" && payload.tab !== null) {
        context.commit("mutationClaims", {
          responseData,
          tab: payload.tab,
        });
      } else {
        context.commit("mutationClaims", responseData);
      }
      context.commit("mutationClaimsMeta", response.meta);

      return response;
    } catch (error) {
      context.commit("mutationClaims", []);
      context.commit("mutationClaimsMeta", {});

      throw error;
    }
  },

  async detailClaim(context, payload) {
    try {
      const response = await this.$api.call("flight.detailClaim", payload);
      const responseData = response.data;

      context.commit("mutationClaim", responseData);

      return response;
    } catch (error) {
      context.commit("mutationClaim", {});
      throw error;
    }
  },

  async listClaimsHistoriesClaim(context, payload) {
    try {
      const response = await this.$api.call(
        "flight.claimsHistoriesClaim",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationListClaimsHistoriesClaim", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListClaimsHistoriesClaim", {});
      throw error;
    }
  },

  async listClaimsHistoriesPolicy(context, payload) {
    try {
      const response = await this.$api.call(
        "flight.claimsHistoriesPolicy",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationListClaimsHistoriesPolicy", responseData);

      return response;
    } catch (error) {
      context.commit("mutationListClaimsHistoriesPolicy", {});
      throw error;
    }
  },

  async listPartners(context, payload) {
    try {
      const response = await this.$api.call("flight.listPartners", payload);
      const responseData = response.data;

      context.commit("mutationPartners", responseData);

      return response;
    } catch (error) {
      context.commit("mutationPartners", []);
      throw error;
    }
  },

  async listProduct(context, payload) {
    try {
      const response = await this.$api.call("flight.listProduct", payload);
      const responseData = response.data;

      context.commit("mutationProducts", responseData);

      return response;
    } catch (error) {
      context.commit("mutationProducts", {});
      throw error;
    }
  },

  async listProductCategory(context, payload) {
    try {
      const response = await this.$api.call(
        "flight.listProductCategory",
        payload,
      );
      const responseData = response.data;
      context.commit("mutationProductCategories", responseData);
      return response;
    } catch (error) {
      context.commit("mutationProductCategories", {});
      throw error;
    }
  },

  async downloadAllPolicy(_context, payload) {
    try {
      const response = await this.$api.call(
        "flight.downloadAllPolicy",
        payload,
      );

      return response;
    } catch (error) {
      throw error;
    }
  },

  async downloadAllClaim(_context, payload) {
    try {
      const response = await this.$api.call("flight.downloadAllClaim", payload);
      return response;
    } catch (error) {
      throw error;
    }
  },

  async getPresignPolicy(_context, payload) {
    try {
      const response = await this.$api.call("flight.getPresignPolicy", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async getPresign(_context, payload) {
    try {
      const response = await this.$api.call("flight.getPresign", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async editPolicy(_context, payload) {
    try {
      const response = await this.$api.call("flight.editPolicy", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async hitPresignUrl(context, { buffer, url }) {
    try {
      const response = await axios.put(url, buffer, {
        onUploadProgress: (progressEvent) => {
          const progress = (progressEvent.loaded / progressEvent.total) * 100;
          context.commit(
            "mutationUploadProgress",
            parseInt(Math.round(progress), 10),
          );
        },
      });
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    } finally {
      context.commit("mutationUploadProgress", 0); // reset uploadProgress to 0 (init state)
    }
  },

  async uploadPolicies(_context, payload) {
    try {
      const response = await this.$api.call("flight.uploadPolicies", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async updateClaim(_context, payload) {
    try {
      const response = await this.$api.call("flight.updateClaim", payload);
      const responseData = response.data;

      return responseData;
    } catch (error) {
      throw error;
    }
  },

  async editPolicyHistory(context, payload) {
    try {
      const response = await this.$api.call(
        "flight.editPolicyHistory",
        payload,
      );
      const responseData = response.data;

      context.commit("mutationEditPolicyHistory", responseData);
      return response;
    } catch (error) {
      context.commit("mutationEditPolicyHistory", []);
      throw error;
    }
  },
};

export default actions;
